import showFilePickerErrorMessage from './errorMessageActions/showFilePickerErrorMessage';
import getFileProviderItemsRequestCount from './helpers/getFileProviderItemsRequestCount';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import FilePickerErrorMessageType from '../types/FilePickerErrorMessageType';
import { action } from 'satcheljs/lib/legacy';

export default action('updateFileProviderItems')(function updateFileProviderItems(
    items: FileProviderItemViewState[],
    viewState: FilePickerPanelViewState,
    requestId: number
) {
    const lastRequestId = getFileProviderItemsRequestCount();

    // We check to make sure the response we are processing is from the most recent request. This prevents us from accidently
    // loading the items from multiple requests, if there were two (or more) requests made before a response was received.
    if (requestId !== lastRequestId) {
        return;
    }

    // Show an error message if there are no items to show
    if (items.length === 0 && viewState.filePickerViewState.fileProviderItems.length === 0) {
        if (viewState.filePickerViewState.searchViewState.isInSearchMode) {
            showFilePickerErrorMessage(
                FilePickerErrorMessageType.NoItemsSearch,
                viewState.filePickerErrorMessageViewState
            );
        } else {
            showFilePickerErrorMessage(
                FilePickerErrorMessageType.NoItems,
                viewState.filePickerErrorMessageViewState
            );
        }
    }

    viewState.filePickerViewState.fileProviderItems = viewState.filePickerViewState.fileProviderItems.concat(
        items
    );
});
